import {h, Fragment} from "preact"
import { SerpElement } from '@nosto/preact'
import { useState } from 'preact/hooks';
import { GIFT_CARD_PRODUCT_ID } from '../config'
import { formatCurrency } from '../helpers'
import MarketingBadge from './MarketingBadge'
import DiscountFlag from './DiscountFlag'
import FlairTags from './FlairTags'

const ProductCardBody = ({ product, giftCard = false, isCategorySelected, collectionDiscountTag }) => {
    const [hovering, setHovering] = useState(false);
    const cjx_shortDescription = (product?.customFields || []).find(cf => cf.key === "cjx-short_description") || {};
    const cjx_discountCode = (product?.customFields || []).find(cf => cf.key === "cjx-discount_code") || {};
    const cjx_flairTags = (product?.customFields || []).find(cf => cf.key === "cjx-flair_tags") || {};
    const cjx_type = (product?.customFields || []).find(cf => cf.key === "cjx-type") || {};
    const cjx_discountTag = (product?.customFields || []).find(cf => cf.key === "cjx-discount_tag") || {};

    let flairTags = [];
    if (cjx_flairTags?.value) {
        try {
            flairTags = JSON.parse(cjx_flairTags.value);
        } catch (e) {
            console.log("Error parsing flair tags:", e);
        }
    }
    const discountPadding = cjx_discountCode?.value ? "with-pr" : "";
    const soldOut = product.availability !== "InStock"; // no serp access to `product.available`

    return (
        <>
            <img
                class="app--listing-card-image"
                src={product.imageUrl}
                alt={product.name}
                width="339"
                height="226"
            />
            {product.alternateImageUrls?.length > 0 && (
                <img
                    class="app--listing-card-image app--listing-card-image-alt"
                    src={product.alternateImageUrls[0]}
                    alt={product.name}
                    width="339"
                    height="226"
                />
            )}

            {cjx_discountCode?.value && (
                <DiscountFlag code={cjx_discountCode.value} tag={cjx_discountTag.value} collectionDiscountTag={collectionDiscountTag} />
            )}

            <div class="app--listing-card-info" data-nosto-element="product">
                {cjx_discountCode?.value && (
                    <MarketingBadge badges={flairTags} />
                )}
                {cjx_type?.value === "One-time" && (
                    <div class="app--listing-card-badge" style="--tw-text-opacity:1;color:rgba(6, 182, 212, var(--tw-text-opacity));">No Subscription Needed</div>
                )}

                <SerpElement
                    as="a"
                    hit={product}
                    class={`app--listing-card-title ${discountPadding}`}
                    onMouseEnter={() => setHovering(true)}
                    onMouseLeave={() => setHovering(false)}
                >
                    {product.name}
                </SerpElement>
                {product.brand && (
                    <div class={`app--listing-card-brand ${discountPadding}`}>
                        by {product.brand}
                    </div>
                )}

                {/* Yotpo Reivew Star */}
                <div class="yotpo-widget-instance"
                    data-yotpo-instance-id="345477"
                    data-yotpo-product-id={product.productId}
                    data-yotpo-section-id="search">
                </div>

                {cjx_shortDescription?.value && (
                    <div class="app--listing-card-desc">
                        {cjx_shortDescription.value}
                    </div>
                )}

                {giftCard ? (
                    <button class={`button button--gc ${hovering ? 'button--hover' : ''}`}>Give a Gift Card</button>
                ) : (
                    <>
                        <div class="app--listing-card-price">
                            From&nbsp;
                            {formatCurrency(product.price)} / box
                        </div>
                        {(cjx_type?.value === "One-time") && (
                            <>
                                <div class="app--listing-card-flair-tag app--listing-card-flair-tag--blue mt-0" style="margin-top: 0;">
                                    One-Time Purchase
                                </div>
                            </>
                        )}
                    </>
                )}

                <FlairTags isCategorySelected={isCategorySelected} flairTags={flairTags} soldOut={soldOut} />

                {/* Wishlist+ / Swym Add to Wishlit Heart */}
                {product?.skus?.length > 0 && (
                    <button
                        data-with-epi="true"
                        class={`swym-button swym-add-to-wishlist-view-product product_${product.productId}`}
                        data-swaction="addToWishlist"
                        data-product-id={product.productId}
                        data-variant-id={product.skus[0].id}
                        data-product-url={product.url}>
                    </button>
                )}
            </div>
        </>
    );
};

const ProductCardNewBody = ({ product, giftCard = false, isCategorySelected, collectionDiscountTag }) => {
    const [hovering, setHovering] = useState(false);
    const cjx_shortDescription = (product?.customFields || []).find(cf => cf.key === "cjx-short_description") || {};
    const cjx_discountCode = (product?.customFields || []).find(cf => cf.key === "cjx-discount_code") || {};
    const cjx_flairTags = (product?.customFields || []).find(cf => cf.key === "cjx-flair_tags") || {};
    const cjx_type = (product?.customFields || []).find(cf => cf.key === "cjx-type") || {};
    const cjx_discountTag = (product?.customFields || []).find(cf => cf.key === "cjx-discount_tag") || {};

    let flairTags = [];
    if (cjx_flairTags?.value) {
        try {
            flairTags = JSON.parse(cjx_flairTags.value);
        } catch (e) {
            console.log("Error parsing flair tags:", e);
        }
    }
    const soldOut = product.availability !== "InStock"; // no serp access to `product.available`

    return (
        <>
            <div class='product-thumb relative product-image-container'>
                <DiscountFlag code={cjx_discountCode.value} tag={cjx_discountTag.value} type={cjx_type} collectionDiscountTag={collectionDiscountTag} />
                <img src={product.imageUrl} alt={product.name} class='w-full image-max-height object-cover' />
                {product.alternateImageUrls?.length > 0 && (
                    <img
                        class="w-full absolute top-0 left-0 opacity-0 image-max-height app--listing-card-image-alt  app-listing-alternate-image object-cover"
                        src={product.alternateImageUrls[0]}
                        alt={product.name}
                    />
                )}
            </div>

            <SerpElement
                as="a"
                hit={product}
                href={product.url}
                onMouseEnter={() => setHovering(true)}
                onMouseLeave={() => setHovering(false)}
                class='streatched-link'
            >
            </SerpElement>

            <div class='mb-2.5'>
                <h6 class='product-text nosto-collection-title'>{product.name}</h6>
                {product.brand && <p class='whitespace-nowrap truncate text-sm text-gray-500 nosto-collection-vendor'>By {product.brand}</p>}
            </div>
            <div class='mb-1 flex gap-1 items-center nosto-collection-rating'>
                <div class='flex gap-1'>
                    <div class="yotpo-widget-instance"
                        data-yotpo-instance-id="345477"
                        data-yotpo-product-id={product.productId}
                        data-yotpo-section-id="search">
                    </div>
                </div>
            </div>

            <p class='my-1 product-search-description nosto-collection-description'>{cjx_shortDescription.value || product.description}</p>
            <h4 className='font-bold text-gray-900 mb-3 text-base mt-0 nosto-collection-price'>
                {(cjx_type?.value === "One-time")
                    ? `$${product.price.toFixed(2)}`
                    : `From $${product.price.toFixed(2)} / Box`}
            </h4>
            <div class='flex flex-wrap items-center flair-gap nosto-collection-label'>
                <FlairTags isCategorySelected={isCategorySelected} flairTags={flairTags} soldOut={soldOut} />
            </div>
        </>
    )
};

export default ({ product, isCategorySelected, collectionDiscountTag }) => {
    const giftCard = +product.productId === +GIFT_CARD_PRODUCT_ID;
    const shouldShowNewSearch = window.cj.nosto.newSearchFeatureEnabled && !isCategorySelected

    return (
        <>
            {shouldShowNewSearch ?
                (<>
                    <div class="app--listing-card search-card-component">
                        {giftCard ? (
                            <div class="app--listing-card-border">
                                <ProductCardNewBody isCategorySelected={isCategorySelected} product={product} giftCard collectionDiscountTag={collectionDiscountTag} />
                            </div>
                        ) : (
                            <ProductCardNewBody isCategorySelected={isCategorySelected} product={product} collectionDiscountTag={collectionDiscountTag} />
                        )}
                    </div>
                </>) : (
                    <div class="app--listing-card">
                        {giftCard ? (
                            <div class="app--listing-card-border">
                                <ProductCardBody isCategorySelected={isCategorySelected} product={product} giftCard collectionDiscountTag={collectionDiscountTag} />
                            </div>
                        ) : (
                            <ProductCardBody isCategorySelected={isCategorySelected} product={product} collectionDiscountTag={collectionDiscountTag} />
                        )}
                    </div>
                )}

        </>
    )
}
